module.exports = __webpack_public_path__ + "static/media/0028_LES_ENSEIGNES_LE_COMPTOIR_DES_SAVEURS.24d3aa93.webp";